import { useState, useEffect } from "react";
import { X, Phone } from "lucide-react";

const ExitIntentPopup = () => {
  const [show, setShow] = useState(false);
  const [phone, setPhone] = useState("");
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    const handleMouseLeave = (e) => {
      if (e.clientY <= 0 && !sessionStorage.getItem("exitPopupShown")) {
        setShow(true);
        sessionStorage.setItem("exitPopupShown", "true");
      }
    };

    // Only trigger on desktop
    if (window.innerWidth > 768) {
      document.addEventListener("mouseleave", handleMouseLeave);
    }

    return () => document.removeEventListener("mouseleave", handleMouseLeave);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!phone) return;

    try {
      const API_URL = process.env.REACT_APP_BACKEND_URL;
      await fetch(`${API_URL}/api/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: "Exit Popup Lead",
          email: "exit-popup@lead.com",
          phone: phone,
          platform: "Not specified",
          message: "Exit intent popup - wants free consultation",
          source: "exit-popup"
        })
      });
    } catch (err) {
      // Still proceed
    }

    // Redirect to WhatsApp with lead details
    const waText = encodeURIComponent(`New Lead from Website!\nPhone: ${phone}\nRequest: Free Marketplace Consultation`);
    window.open(`https://wa.me/919464645491?text=${waText}`, '_blank');

    setSubmitted(true);
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" data-testid="exit-intent-popup">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 relative animate-scaleIn">
        <button
          onClick={() => setShow(false)}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition"
        >
          <X size={24} />
        </button>

        {!submitted ? (
          <>
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-gradient-to-r from-red-500 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <Phone className="text-white" size={28} />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">
                Wait! Get Free Consultation
              </h3>
              <p className="text-gray-600">
                Our marketplace expert will call you within 30 minutes and help you launch your brand.
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              <input
                type="tel"
                placeholder="Enter your phone number"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-red-500 focus:outline-none text-lg"
                required
                data-testid="exit-popup-phone"
              />
              <button
                type="submit"
                className="w-full bg-gradient-to-r from-red-500 to-orange-500 text-white py-3 rounded-xl font-bold text-lg hover:shadow-lg transition-all"
                data-testid="exit-popup-submit"
              >
                Get Free Callback
              </button>
            </form>

            <p className="text-xs text-gray-400 text-center mt-4">
              No spam. We'll only call once to discuss your requirements.
            </p>
          </>
        ) : (
          <div className="text-center py-4">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2">We'll Call You Soon!</h3>
            <p className="text-gray-600">Our expert will reach out within 30 minutes.</p>
            <button
              onClick={() => setShow(false)}
              className="mt-6 px-6 py-2 bg-gray-100 text-gray-700 rounded-full hover:bg-gray-200 transition"
            >
              Close
            </button>
          </div>
        )}
      </div>

      <style jsx>{`
        @keyframes scaleIn {
          from { opacity: 0; transform: scale(0.9); }
          to { opacity: 1; transform: scale(1); }
        }
        .animate-scaleIn { animation: scaleIn 0.3s ease-out; }
      `}</style>
    </div>
  );
};

export default ExitIntentPopup;
